import { MeterStatusThresholdDraft } from "@/shared/models/MeterStatusThreshold";
import {
	getMeterStatusBands,
	METER_STATUS_LABELS,
	MeterStatusLevel,
	MeterStatusMetric,
} from "@/shared/utils/meterStatusLevels";
import { Box, InputAdornment, TextField } from "@mui/material";

type Props = {
	drafts: MeterStatusThresholdDraft[];
	metric: MeterStatusMetric;
	max: number;
	disabled: boolean;
	onChange: (level: MeterStatusLevel, value: number) => void;
};

export const MeterStatusBoundaryFields = ({
	drafts,
	metric,
	max,
	disabled,
	onChange,
}: Props) => {
	const unit = metric === "Lag" ? "h" : "%";

	return (
		<Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
			{getMeterStatusBands(drafts, metric)
				.slice(1)
				.map((band) => (
					<TextField
						key={band.Level}
						size="small"
						type="number"
						label={`${METER_STATUS_LABELS[band.Level]} starts at`}
						value={band.Threshold}
						disabled={disabled}
						inputProps={{ max, min: 0, step: 1 }}
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<Box sx={{ fontSize: "0.75rem" }}>{unit}</Box>
								</InputAdornment>
							),
						}}
						onChange={(event) => {
							if (event.target.value === "") return;
							const value = Number(event.target.value);
							if (Number.isFinite(value)) onChange(band.Level, value);
						}}
						sx={{ width: 168 }}
					/>
				))}
		</Box>
	);
};
